export default __webpack_public_path__ + "static/media/arrow_forward.aba1647c.svg";